<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6C0 5.44772 0.447715 5 1 5H7C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H1C0.447715 7 0 6.55228 0 6Z"
      fill="currentColor"
    />
    <path
      d="M0 10C0 9.44772 0.447715 9 1 9H7C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11H1C0.447715 11 0 10.5523 0 10Z"
      fill="currentColor"
    />
    <path
      d="M0 14C0 13.4477 0.447715 13 1 13H5C5.55228 13 6 13.4477 6 14C6 14.5523 5.55228 15 5 15H1C0.447715 15 0 14.5523 0 14Z"
      fill="currentColor"
    />
    <path
      d="M10 5C10 4.44772 10.4477 4 11 4H19C19.5523 4 20 4.44772 20 5V15C20 15.5523 19.5523 16 19 16H11C10.4477 16 10 15.5523 10 15V5Z"
      fill="currentColor"
    />
  </svg>
</template>
